import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "target"]
  static classes = ["hidden"]
  // A select source shows the targets while its value is this one; a checkbox, while checked.
  static values = { shownValue: String }

  connect() {
    this.toggle()
  }

  toggle() {
    const shown = this.hasShownValueValue ? this.sourceTarget.value === this.shownValueValue : this.sourceTarget.checked
    this.targetTargets.forEach(el => {
      if (shown) {
        el.classList.remove(this.hiddenClass)
      } else {
        el.classList.add(this.hiddenClass)
      }
    })
  }
}
